import { EventEmitter, Injectable, isDevMode } from '@angular/core';
/**
 * @hidden
 */
var ExcelService = /** @class */ (function () {
    function ExcelService() {
        this.saveToExcel = new EventEmitter();
        this.exportClick = new EventEmitter();
    }
    ExcelService.prototype.save = function (component) {
        if (this.saveToExcel.observers.length === 0) {
            if (isDevMode()) {
                throw new Error('Saving excel requires including the ExcelModule and adding the <kendo-grid-excel> component.');
            }
        }
        else {
            this.saveToExcel.emit(component);
        }
    };
    ExcelService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    ExcelService.ctorParameters = function () { return []; };
    return ExcelService;
}());
export { ExcelService };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-grid/dist/es/excel/excel.service.js
// module id = ../../../../@progress/kendo-angular-grid/dist/es/excel/excel.service.js
// module chunks = vendor